import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useChannels, useKickEnabled } from '../lib/queries'
import ChannelCard from '../components/ChannelCard'
import AppShell from '../components/AppShell'
import Button from '../components/ui/Button'

export default function Dashboard() {
  const navigate = useNavigate()
  const { data: channels = [], isLoading, isError } = useChannels()
  const { data: oauthData } = useKickEnabled()
  const oauthEnabled = oauthData?.enabled ?? false
  const [msg, setMsg] = useState('')

  // Tek kanal varsa otomatik o kanala git — `?stay=1` override
  useEffect(() => {
    if (isLoading) return
    if (channels.length === 1 && !window.location.search.includes('stay=1')) {
      navigate(`/channels/${channels[0].id}`, { replace: true })
    }
  }, [isLoading, channels, navigate])

  // 401 → login'e yönlendir
  useEffect(() => {
    if (isError) navigate('/login')
  }, [isError, navigate])

  // OAuth callback query param mesajları
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.has('kick_connected')) {
      const slug = params.get('kick_connected')
      const replaced = params.has('owner_replaced')
      setMsg(`Kick bağlandı: ${slug}${replaced ? ' (önceki sahip değiştirildi)' : ''}`)
      window.history.replaceState({}, '', window.location.pathname)
    } else if (params.has('kick_connected_no_slug')) {
      setMsg('Kick bağlandı ama kanal bilgisi alınamadı. "Kick\'i bağla" ile tekrar dene.')
      window.history.replaceState({}, '', window.location.pathname)
    } else if (params.has('kick_no_channel')) {
      // LoginCallback'ten gelir — hesap oluşturuldu ama kanal eklenemedi.
      setMsg('Hoş geldin! Hesabın hazır ama kanal otomatik bağlanamadı. Aşağıdan "Kick\'i bağla" butonuna bas.')
      window.history.replaceState({}, '', window.location.pathname)
    } else if (params.has('kick_error')) {
      setMsg(params.get('kick_error') || 'Kick hatası')
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, [])

  function bindKick() {
    const token = localStorage.getItem('auth.token')
    if (!token) return
    const apiBase = import.meta.env.VITE_API_BASE || 'http://localhost:8080'
    window.location.href = `${apiBase}/api/auth/kick/start?token=${encodeURIComponent(token)}`
  }

  return (
    <AppShell>
      <div className="max-w-5xl mx-auto px-6 py-8">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h1 className="text-xl font-semibold">Kanallar</h1>
            <p className="text-sm text-[var(--color-text-muted)] mt-1">
              Yönettiğin Kick kanalları
            </p>
          </div>
          {oauthEnabled && (
            <Button onClick={bindKick} variant="primary">
              <span>+</span> Kanal bağla
            </Button>
          )}
        </div>

        {msg && (
          <div className="mb-4 px-4 py-2.5 rounded-lg bg-[var(--color-accent-soft)] border border-[var(--color-accent)]/30 text-sm text-[var(--color-text)]">
            {msg}
          </div>
        )}

        {isLoading ? (
          <div className="text-sm text-[var(--color-text-muted)]">Yükleniyor…</div>
        ) : channels.length === 0 ? (
          <div className="rounded-lg border border-dashed border-[var(--color-border)] p-12 text-center">
            <div className="text-base font-medium mb-1">Henüz kanal yok</div>
            <p className="text-sm text-[var(--color-text-muted)] mb-4">
              {oauthEnabled
                ? 'Kick OAuth ile bir kanal bağlayarak başla.'
                : 'OAuth backend yapılandırılmamış.'}
            </p>
            {oauthEnabled && (
              <Button onClick={bindKick} variant="primary">
                Kanal bağla
              </Button>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {channels.map((ch) => (
              <ChannelCard
                key={ch.id}
                channel={ch}
                onClick={() => navigate(`/channels/${ch.id}`)}
              />
            ))}
          </div>
        )}
      </div>
    </AppShell>
  )
}
